<div class="h-100 box d-flex flex-column px-2 pb-5 relative">
    <ng-container *ngIf="loaded$ | async">
        <div class="px-4">
            <div class="d-flex g-0 border-b border-dark py-5">
                <div class="icon icon-xxl icon-default me-4" inlineSVG="assets/icons.svg#alert-warning"></div>
                <div class="col">
                    <div class="text-l font-semi-bold mb-4">
                        <span class="text-danger">
                            <ng-container *ngIf="count$ | async as count">
                                {{ count ? count : '...' }}
                            </ng-container>
                        </span>
                        {{ 'v3-byoc-popup-create-episode-users-title' | translate }}
                    </div>
                    <div class="text-xs font-semi-bold text-default">
                        {{
                            'v3-byoc-popup-create-episode-users-description'
                                | translate: { courseName: courseName$ | async, missionNames: missionNames$ | async }
                        }}
                    </div>
                </div>
            </div>
        </div>

        <div class="flex-grow-1">
            <div class="py-4 px-4 relative inner h-100">
                <div class="text-xs text-muted font-semi-bold mb-4">
                    {{ 'v3-byoc-popup-create-episode-users-learners-affected' | translate }}
                </div>

                <app-byoc-episode-step-users-list></app-byoc-episode-step-users-list>
            </div>
        </div>

        <div class="theme-new d-flex align-items-center px-4">
            <button (click)="backClick()" class="btn btn-primary ms-auto" buttonDataTest="backButton" translate>v3-button-go-back-and-edit</button>
            <ng-container *ngIf="!canEditEpisodeAndUploadNewContent; else reuploadButton">
                <button (click)="publishClick()" class="btn btn-secondary" buttonDataTest="publishButton" translate>v3-button-confirm</button>
            </ng-container>
            <ng-template #reuploadButton>
                <button (click)="reuploadAndPublish()" class="btn btn-secondary" buttonDataTest="publishButton" translate>v3-button-confirm</button>
            </ng-template>
        </div>
    </ng-container>

    <div
        *ngIf="(saving$ | async) || (loaded$ | async) === false || (reuploadLoading$ | async)"
        [ngClass]="((reuploadLoading$ | async) || (saving$ | async)) && (count$ | async) !== 0 ? '' : 'loader-box d-flex align-items-center'"
    >
        <app-loader loaderType="cover" overlayColor="white"></app-loader>
    </div>
</div>
